import ModalTextField from 'components/ModalTextField';
import { CalculateFieldNames } from 'utils/constants/fieldNames';
import { HeadcountSectionProps } from 'interfaces/components/dataEntryModal/HeadcountSection';
import {
  gaFteField,
  opexPerFteField,
  rdFteField,
  smFteField
} from 'utils/constants/fields';

const HeadcountSection = ({
  headcountParentRef,
  headcountRef,
  opexPerFTE,
  onOpexPerFTEChange,
  gAHead,
  onGAHeadChange,
  sMHead,
  onSMHeadChange,
  rDHead,
  onRDHeadChange,
  totalHeadcount,
  handleCalculateBtnClick
}: HeadcountSectionProps) => {
  return (
    <div className='w-full' ref={headcountParentRef}>
      <div
        className='w-full flex flex-col items-start gap-4 scroll-mt-3'
        ref={headcountRef}
      >
        <p className='text-[24px] leading-[19.2px] font-light'>Headcount</p>
        <div className='w-full grid grid-cols-2 gap-4'>
          <ModalTextField
            {...opexPerFteField}
            value={opexPerFTE ? opexPerFTE : ''}
            onChange={onOpexPerFTEChange}
            showCalculateBtn
            onCalculateBtnClick={() =>
              handleCalculateBtnClick(CalculateFieldNames.OPEX_PER_FTE)
            }
          />
        </div>
        <p className='text-[20px] leading-[19.2px] font-light'>
          Headcount Distribution ({totalHeadcount} Total FTEs)
        </p>
        <div className='w-full grid grid-cols-2 gap-4'>
          <ModalTextField
            {...gaFteField}
            value={gAHead ? gAHead : ''}
            onChange={onGAHeadChange}
            showCalculateBtn
            onCalculateBtnClick={() =>
              handleCalculateBtnClick(CalculateFieldNames.GA_HEADCOUNT)
            }
          />
          <ModalTextField
            {...smFteField}
            value={sMHead ? sMHead : ''}
            onChange={onSMHeadChange}
            showCalculateBtn
            onCalculateBtnClick={() =>
              handleCalculateBtnClick(CalculateFieldNames.SM_HEADCOUNT)
            }
          />
          <ModalTextField
            {...rdFteField}
            value={rDHead ? rDHead : ''}
            onChange={onRDHeadChange}
            showCalculateBtn
            onCalculateBtnClick={() =>
              handleCalculateBtnClick(CalculateFieldNames.RD_HEADCOUNT)
            }
          />
          {(!!rDHead && (!gAHead || !sMHead)) ||
          (!!sMHead && (!rDHead || !gAHead)) ||
          (!!gAHead && (!sMHead || !rDHead)) ||
          ((!!rDHead || !!gAHead || !!sMHead) &&
            Number(rDHead) + Number(gAHead) + Number(sMHead) !==
              Number(totalHeadcount)) ? (
            <p className='mt-8 text-sm font-light text-red-500'>
              All or none of the FTEs values can be empty
              <br /> Total FTEs must be equal to Total Headcount (
              {totalHeadcount})
            </p>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default HeadcountSection;
